import { useState } from 'react';
import { resolvePeerDisplayName, trackPeerNameMemory } from './peerWaiting';
/**
 * The partner pane's name (peerWaiting.ts resolvePeerDisplayName): the
 * present participant's own name, else the stored name until the person it
 * named has been in the pane and left, else '' for the role noun.
 *
 * The memory is adjusted during render, the way React documents for state
 * derived from earlier renders, so the very render that shows the pane empty
 * again already drops the departed name (nothing stale reaches the live
 * region first).
 */
export function usePeerDisplayName(storedName, present, presentName) {
    const [memory, setMemory] = useState({ present: false });
    const next = trackPeerNameMemory(memory, present, storedName);
    if (next !== memory) {
        setMemory(next);
    }
    return resolvePeerDisplayName({ memory: next, present, presentName, storedName });
}
